export default function PartnerBenefits() {
  const signals = [
    { icon: 'ri-compass-3-line', label: 'Things to do' },
    { icon: 'ri-shield-check-line', label: 'Services they can trust' },
    { icon: 'ri-chat-heart-line', label: 'Recommendations they don\'t have to second guess' },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Left — text */}
          <div>
            <span className="text-xs font-bold tracking-widest uppercase text-rose-500 mb-4 block">Why It Works</span>
            <h2 className="text-4xl font-extrabold text-gray-900 leading-tight mb-6">
              Our community isn&apos;t
              <span className="text-rose-500"> passive</span>
              <span className="text-gray-900"> — it&apos;s active.</span>
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              Our community is made up of moms actively planning, booking, and making decisions for their families.
            </p>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              When your business is featured here, you&apos;re placed directly in that decision flow — not just seen, but trusted.
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              Moms here are looking for:
            </p>
            <ul className="space-y-4 mb-10">
              {signals.map((s) => (
                <li key={s.label} className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-rose-50 rounded-xl shrink-0">
                    <i className={`${s.icon} text-rose-500 text-base`}></i>
                  </div>
                  <span className="text-gray-700 text-sm font-medium">{s.label}</span>
                </li>
              ))}
            </ul>
            <div className="border-l-4 border-rose-300 pl-5 py-1">
              <p className="text-gray-600 text-sm leading-relaxed">
                When your business is featured here, you&apos;re placed directly in that decision flow.
              </p>
            </div>
          </div>

          {/* Right — image + trust badge */}
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/fbd4495d0a6cc39d7128d7e532885010.jpg"
              alt="Local moms at community event"
              className="w-full h-[480px] object-cover object-top rounded-2xl"
            />
            <div className="absolute -bottom-5 -left-5 bg-white rounded-2xl px-6 py-4 border border-gray-100">
              <p className="text-xl font-extrabold text-gray-900">1,000+</p>
              <p className="text-xs text-gray-400 mt-0.5">Active local families</p>
            </div>
          </div>
        </div>

        {/* Bottom supporting line */}
        <div className="mt-20 text-center">
          <p className="text-gray-400 text-sm max-w-lg mx-auto leading-relaxed">
            We keep this platform valuable for moms — and that means we&apos;re selective about who we feature.
          </p>
        </div>
      </div>
    </section>
  );
}
